import { FC, useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'

interface PopperWithArrowProps {
  anchorEl: HTMLElement | null
  open: boolean
  id?: string
}

const PopperWithArrow: FC<PopperWithArrowProps> = ({
  anchorEl,
  children,
  open,
  id,
}) => {
  const [openPopper, setOpenPopper] = useState<boolean>(open)
  const popperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setOpenPopper(open)
  }, [open])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popperRef.current &&
        !popperRef.current.contains(event.target as Node) &&
        anchorEl &&
        !anchorEl.contains(event.target as Node)
      ) {
        setOpenPopper(false)
      }
    }

    if (openPopper) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [anchorEl, openPopper])

  if (!anchorEl) return null

  return (
    <StyledWrapper id={id} ref={popperRef} isOpen={openPopper}>
      <div className="arrow-wrapper">
        <div className="arrow" />
      </div>
      <div className="popper-children">{children}</div>
    </StyledWrapper>
  )
}

export default PopperWithArrow

const StyledWrapper = styled.div<{ isOpen: boolean }>`
  position: absolute;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  margin-top: 8px;
  z-index: 1;
  ${mobileBreakPoint} {
    right: 0;
  }

  .arrow-wrapper {
    position: relative;
    width: 0;
    left: 30px;
    border-right: solid 5px transparent;
    border-left: solid 5px transparent;
    border-bottom: solid 8px #ccc;
    ${mobileBreakPoint} {
      position: absolute;
      top: -8px;
      right: 80px;
      left: unset;
    }
  }

  .arrow {
    position: absolute;
    top: 2px;
    left: -5px !important;
    width: 0;
    border-right: solid 5px transparent;
    border-left: solid 5px transparent;
    border-bottom: solid 8px white;
    border-radius: 5px;
  }

  .popper-children {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 20px;
    background-color: white;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  }
`
